import apiFetch from '../apiFetch'

export default function (token, faqSectionId) {
  return apiFetch({ endPoint: `FaqSection/${faqSectionId}`, method: 'GET', body: null, token: token })
}
